export const themesList = {
  mainTheme: {
    colorPrimary: '#053170',
    mainColor: '#FFFFFF',
    tableHeaderColor: '#000000',
    colorBgLayout: '#5eaec6',
    colorPrimaryBgHover: '#053170',
    colorBorderSecondary: '#93b1c1',
    colorBgSpotlight: '#053170',
    inputBorderColor: '#053170',
    inputColorPrimary: '#053170',
    colorFillContent: '#ffb58a',
    colorFillContentHover: '#f69906',
    colorFillQuaternary: '#81b2cd',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(5,49,112,0.05)',
    actionButtons: '#053170',
    actionButtonsHover: '#63a0c0',
    logoutBtn: '#053170',
    logoutBtnHover: '#63a0c0',
  },
  contrastBloom: {
    colorPrimary: '#1b1860',
    mainColor: '#FFFFFF',
    tableHeaderColor: '#000000',
    colorBgLayout: '#162b48',
    colorPrimaryBgHover: '#3a68aa',
    colorBorderSecondary: '#44a7fb',
    colorBgSpotlight: '#3a68aa',
    inputBorderColor: '#1b1860',
    inputColorPrimary: '#1b1860',
    colorFillContent: '#765cc9',
    colorFillContentHover: '#a470da',
    colorFillQuaternary: '#c065a2',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(27,24,96,0.05)',
    actionButtons: '#1b1860',
    actionButtonsHover: '#3a68aa',
    logoutBtn: '#1b1860',
    logoutBtnHover: '#3a68aa',
    treeTextColor: '#ffffff',
    treeBorderColor: '#eaecef',
    treeTitleBg: '#44a7fb',
  },
  firstTheme: {
    colorPrimary: '#44a7fb',
    mainColor: '#ffffff',
    tableHeaderColor: '#ffffff',
    colorBgLayout: '#010405',
    colorPrimaryBgHover: '#3a68aa',
    colorBorderSecondary: '#93b1c1',
    colorBgSpotlight: '#3a68aa',
    inputBorderColor: '#3a68aa',
    inputColorPrimary: '#63a0c0',
    colorFillContent: '#141c2a',
    colorFillContentHover: '#1c2635',
    colorFillQuaternary: '#162b48',
    shadow: '0 6px 24px rgba(0,0,0,.5), 0 2px 8px rgba(68,167,251,.08)',
    actionButtons: '#3a68aa',
    actionButtonsHover: '#2c5280',
    logoutBtn: '#c065a2',
    logoutBtnHover: '#a0548c',
    treeTextColor: '#ffffff',
  },
  secondTheme: {
    colorPrimary: '#1A73E8',
    mainColor: '#ffffff',
    tableHeaderColor: '#000000',
    colorBgLayout: '#F9FAFB',
    colorPrimaryBgHover: '#145ABD',
    colorBorderSecondary: '#63A0C0',
    colorBgSpotlight: '#3A68AA',
    inputBorderColor: '#63A0C0',
    inputColorPrimary: '#3A68AA',
    colorFillContent: '#E5E7EB',
    colorFillContentHover: '#D1D5DB',
    colorFillQuaternary: '#D6E4FF',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(58,104,170,0.05)',
    actionButtons: '#1A73E8',
    actionButtonsHover: '#145ABD',
    logoutBtn: '#C065A2',
    logoutBtnHover: '#A0548C',
  },
  fifthTheme: {
    colorPrimary: '#C065A2',
    mainColor: '#ffffff',
    tableHeaderColor: '#000000',
    colorBgLayout: '#FFF0F6',
    colorPrimaryBgHover: '#A0548C',
    colorBorderSecondary: '#A0AEC0',
    colorBgSpotlight: '#C065A2',
    inputBorderColor: '#C065A2',
    inputColorPrimary: '#C065A2',
    colorFillContent: '#FFD6E0',
    colorFillContentHover: '#FFCCE5',
    colorFillQuaternary: '#F8E6F1',
    shadow: '0 2px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(192,101,162,0.05)',
    actionButtons: '#C065A2',
    actionButtonsHover: '#A0548C',
    logoutBtn: '#C065A2',
    logoutBtnHover: '#A0548C',
  },
  seventhTheme: {
    colorPrimary: '#2E8B57',
    mainColor: '#ffffff',
    tableHeaderColor: '#000000',
    colorBgLayout: '#F1F8F4',
    colorPrimaryBgHover: '#1F5E3A',
    colorBorderSecondary: '#DCE5DD',
    colorBgSpotlight: '#2E8B57',
    inputBorderColor: '#2E8B57',
    inputColorPrimary: '#2E8B57',
    colorFillContent: '#D9F2E2',
    colorFillContentHover: '#E6F4EA',
    colorFillQuaternary: '#DCE5DD',
    shadow: '0 2px 6px rgba(0,0,0,0.08), 0 1px 3px rgba(46,139,87,0.05)',
    actionButtons: '#2E8B57',
    actionButtonsHover: '#1F5E3A',
    logoutBtn: '#2E8B57',
    logoutBtnHover: '#1F5E3A',
    focusRing: '#2E8B57',
    colorAccentMint: '#A7E8BD',
    colorAccentLime: '#C9F04A',
    colorAccentTeal: '#3CAEA3',
  },
  eighthTheme: {
    colorPrimary: '#5a6f94',
    mainColor: '#fff',
    tableHeaderColor: '#ffffff',
    colorBgLayout: 'rgba(172, 196, 221, 0.6)',
    colorPrimaryBgHover: 'rgba(103, 189, 197, 1) ',
    colorBorderSecondary: '#fff',
    colorBgSpotlight: '#5a6f94',
    inputBorderColor: '#5a6f94',
    inputColorPrimary: '#5a6f94',
    colorFillContent: '#5a6f94',
    colorFillContentHover: 'rgba(172, 196, 221, 0.8)',
    colorFillQuaternary: '#5a6f94',
    shadow:
      '-90px 0 60px -30px #5a6f94 inset, 90px 0px 60px -30px #5a6f94 inset',
    actionButtons: 'rgba(103, 189, 197, 1)',
    actionButtonsHover: 'rgba(83, 163, 170, 1)',
    logoutBtn: '#C94C4C',
    logoutBtnHover: '#A63E3E',
  },
  lilacTheme: {
    colorPrimary: '#9A97D6',
    mainColor: '#ffffff',
    tableHeaderColor: '#000000',
    colorBgLayout: '#E8E9F7',
    colorPrimaryBgHover: '#7F7BC4',
    colorBorderSecondary: '#D8B4FE',
    colorBgSpotlight: '#9A97D6',
    inputBorderColor: '#9A97D6',
    inputColorPrimary: '#9A97D6',
    colorFillContent: '#D5D3F0',
    colorFillContentHover: '#E8E9F7',
    colorFillQuaternary: '#E8E9F7',
    shadow: '0 2px 6px rgba(0,0,0,0.08), 0 1px 3px rgba(154,151,214,0.05)',
    actionButtons: '#9A97D6',
    actionButtonsHover: '#7F7BC4',
    logoutBtn: '#9A97D6',
    logoutBtnHover: '#7F7BC4',
    focusRing: '#9A97D6',
    colorAccentPurple: '#7F7BC4',
    colorAccentLavender: '#E9D5FF',
    colorAccentViolet: '#9333EA',
    colorPrimaryText: '#000000',
  },
  ninethTheeme: {
    colorPrimary: 'rgb(243,174,65)',
    mainColor: 'rgb(225, 215, 204)',
    tableHeaderColor: '#000000',
    colorBgLayout: 'rgb(225, 215, 204)',
    colorPrimaryBgHover: '#6e5c4e',
    colorBorderSecondary: '#fff',
    colorBgSpotlight: '#6e5c4e',
    inputBorderColor: '#6e5c4e',
    inputColorPrimary: '#6e5c4e',
    colorFillContent: '#6e5c4e',
    colorFillContentHover: '#6e5c4e',
    colorFillQuaternary: '#6e5c4e',
    shadow:
      '-90px 0 60px -30px #6e5c4e inset, 90px 0px 60px -30px #6e5c4e inset',
    actionButtons: '#c99d41',
    actionButtonsHover: '#d0aa5b',
    logoutBtn: '#C94C4C',
    logoutBtnHover: '#A63E3E',
  },
};
